goog.provide('el8.appchart.refpanel.hccScoreDetails');

goog.require('el8.service.urls');
goog.require('el8.template.appchart.refpanel.hccScoreDetails');
goog.require('el8.uiwidget.NewDialog');
goog.require('el8.uiwidget.ButtonSet');

/**
 * HCC Score details dialog
 *
 */
el8.appchart.refpanel.hccScoreDetails = (function() {
    var that = new el8.uiwidget.NewDialog({
        title: 'Risk Assessment Details',
        autoHeight: true,
        position: 'center',
        width: 600,
        showXButton: true
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton('ok', 'OK', function() {
        that.hide();
    }, true);
    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        bindTriggers();
    };

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        super_show.call(that);

        that.getContentElt().html(
            el8.template.appchart.refpanel.hccScoreDetails.content({
                data: el8.ptdata.hccScoreDetails.asSoyMap()
            })
        );

        that._tabbedNav = new el8.uiwidget.TabbedNav();
        that._tabbedNav.init({
            wrapper: $('.tabbed-nav', that.getContentElt()),
            tabItemClass: 'el8TabItemSmall'
        });

        that._tabbedNav.addTab({
            title: "Community (non-dual)",
            name: "community",
            contentDiv: $(".hcc-detail-community", that.getContentElt()),
            showTabFn: function() {
                that.adjustPosition();
            }
        });

        that._tabbedNav.addTab({
            title: "Institutional",
            name: "institution",
            contentDiv: $(".hcc-detail-institutional", that.getContentElt()),
            showTabFn: function() {
                that.adjustPosition();
            }
        });

        that._tabbedNav.showTab('community');

        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
    };

    function bindTriggers() {}

    return that;
})();
